<template>
  <div>
    <v-dialog transition="dialog-bottom-transition" v-model="loading"  persistent width="300">
      <v-card color="teal lighten-1" dark>
        <v-card-text>
          Recuperation des données
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: true,
    }
  }
}
</script>